import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '../../../core';

const modifiers = {
  small: () => ({
    styles: `
      width: ${rem(40)};
      height: ${rem(40)};
    `,
  }),

  medium: () => ({
    styles: `
      width: ${rem(60)};
      height: ${rem(60)};
    `,
  }),
  large: () => ({
    styles: `
      width: ${rem(80)};
      height: ${rem(80)};
    `,
  }),
  xLarge: () => ({
    styles: `
      width: ${rem(120)};
      height: ${rem(120)};
    `,
  }),
  wBorder: ({ theme }) => ({
    styles: `
      border: solid ${rem(5)} ${theme.primary.main};
    `,
  }),
  light: () => ({
    styles: `
      font-weight: 500;
    `,
  }),
};

export const ImageRoundedStyled = styled.div.attrs({
  className: 'component__imageRounded',
})`
  width: ${rem(50)};
  height: ${rem(50)};
  line-height: 1;
  background-color: #EEE;
  border-radius: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  ${applyStyleModifiers(modifiers)}

  img {
    max-width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

`;
